__turbopack_context__.v({
  "root": "m2s_Zq_root",
  "rootdisabled": "m2s_Zq_rootdisabled",
  "spinnerIcon": "m2s_Zq_spinnerIcon",
  "spinnerIcon2": "m2s_Zq_spinnerIcon2",
  "spinnerIcon2light": "m2s_Zq_spinnerIcon2light",
  "spinnerIcon3": "m2s_Zq_spinnerIcon3",
  "spinnerIcon3disabled": "m2s_Zq_spinnerIcon3disabled",
  "spinnerIcondisabled": "m2s_Zq_spinnerIcondisabled",
});
